export default __webpack_public_path__ + "static/media/introduction-dark.f869dc90.svg";